export default "__VITE_ASSET__Bt2qwWP1__"